<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="800px"
  >
    <!--<editor-fold desc="Dialog Header">-->
    <template slot="dialogTitle">
      <span v-if="navigareCompanyDirty.id">
        Edit {{ navigareCompanyDirty.name }}
      </span>
      <span v-else>
        Add New Company
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-text-field
        v-model="navigareCompanyDirty.name"
        v-validate="'required'"
        name="name"
        label="Name"
        outlined
        :error-messages="veeErrors.collect('name')"
      />
      <v-autocomplete
        v-model="navigareCompanyDirty.country_id"
        v-validate="'required'"
        :items="countries.data"
        :loading="countries.loading"
        name="country_id"
        item-value="id"
        item-text="name"
        label="Country"
        autocomplete="new-password"
        outlined
        data-vv-as="country"
        :error-messages="veeErrors.collect('country_id')"
      />
      <v-text-field
        v-model="navigareCompanyDirty.tax_id"
        v-validate="'required'"
        name="tax_id"
        label="Tax ID"
        outlined
        data-vv-as="Tax ID"
        :error-messages="veeErrors.collect('tax_id')"
      />
      <v-text-field
        v-model="navigareCompanyDirty.representative_name"
        v-validate="'required'"
        name="representative_name"
        label="Representative name"
        hint="Enter full name"
        outlined
        data-vv-as="representative name"
        :error-messages="veeErrors.collect('representative_name')"
      />
      <v-switch
        v-model="navigareCompanyDirty.parent"
        label="Parent Company"
      />
      <!--<editor-fold desc="Contact Details">-->
      <v-subheader>
        Contact Details
      </v-subheader>
      <v-text-field
        v-model="navigareCompanyDirty.contact_details.email"
        v-validate="'required'"
        name="contact_details_email"
        label="Email"
        outlined
        data-vv-as="email"
        :error-messages="veeErrors.collect('contact_details_email')"
      />
      <v-text-field
        v-model="navigareCompanyDirty.contact_details.telephone"
        v-validate="'required'"
        name="contact_details_telephone"
        label="Telephone"
        outlined
        data-vv-as="telephone"
        :error-messages="veeErrors.collect('contact_details_telephone')"
      />
      <v-text-field
        v-model="navigareCompanyDirty.contact_details.address"
        v-validate="'required'"
        name="contact_details_address"
        label="Company Official Address"
        outlined
        data-vv-as="address"
        :error-messages="veeErrors.collect('contact_details_address')"
      />
      <v-text-field
        v-model="navigareCompanyDirty.contact_details.delivery_address"
        label="Delivery Address"
        outlined
      />
      <v-text-field
        v-model="navigareCompanyDirty.contact_details.city"
        v-validate="'required'"
        name="contact_details_city"
        label="City"
        outlined
        data-vv-as="city"
        :error-messages="veeErrors.collect('contact_details_city')"
      />
      <!--</editor-fold>-->
      <!--<editor-fold desc="Bank Accounts Details">-->
      <v-subheader class="justify-space-between pr-0 mt-6">
        Bank Accounts
        <v-btn
          text
          color="grey"
          @click="addBankAccount"
        >
          <v-icon
            small
            left
          >
            add
          </v-icon>
          Add
        </v-btn>
      </v-subheader>
      <template
        v-for="(bankAccount, i) in navigareCompanyDirty.bank_accounts"
      >
        <div
          :key="i"
          class="py-1 list--bordered text-right"
        >
          <v-btn
            v-if="i > 0"
            class="mx-0"
            text
            small
            @click="removeBankAccount(i)"
          >
            <v-icon
              color="red"
              small
              left
            >
              close
            </v-icon>
            Remove Bank Account
          </v-btn>
          <v-select
            v-model="bankAccount.currency"
            v-validate="'required'"
            :items="currencies"
            :name="'bank_account_currency-'+i"
            label="Currency"
            outlined
            data-vv-as="currency"
            :error-messages="veeErrors.collect('bank_account_currency-'+i)"
          />
          <v-text-field
            v-model="bankAccount.bank_name"
            v-validate="'required'"
            :name="'bank_account_bank_name-'+i"
            label="Bank Name"
            outlined
            data-vv-as="bank name"
            :error-messages="veeErrors.collect('bank_account_bank_name-'+i)"
          />
          <v-text-field
            v-model="bankAccount.iban"
            v-validate="'required'"
            :name="'bank_account_iban-'+i"
            label="IBAN"
            outlined
            data-vv-as="IBAN"
            :error-messages="veeErrors.collect('bank_account_iban-'+i)"
          />
          <v-text-field
            v-model="bankAccount.bic"
            v-validate="'required'"
            :name="'bank_account_bic-'+i"
            label="BIC/SWIFT"
            outlined
            data-vv-as="BIC/SWIFT"
            :error-messages="veeErrors.collect('bank_account_bic-'+i)"
          />
        </div>
      </template>

      <!--</editor-fold>-->
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-btn
        v-if="navigareCompanyDirty.id && $can('delete', 'NavigareCompany')"
        small
        outlined
        color="error"
        @click="toggleConfirmationDialog(true)"
      >
        <v-icon
          left
          small
        >
          delete
        </v-icon>
        Delete
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      text="Are you sure you want to delete this Company?"
      @confirmed="deleteNavigareCompany"
    />
  </content-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import NavigareCompany from '@/models/NavigareCompany'
import CurrencyExchangeRate from '@/models/CurrencyExchangeRate'
import ContentDialog from '@/components/helpers/Dialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'

export default {
    name: 'NavigareCompanyEditDialog',
    components: {
      ContentDialog,
      ConfirmDeleteDialog
    },
    mixins: [deleteConfirmationMixin],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      navigareCompany: {
        type: Object,
        default: () => NavigareCompany.emptyModel
      }
    },
    data() {
      return {
        navigareCompanyDirty: cloneDeep(NavigareCompany.emptyModel),
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      currencies() {
        return CurrencyExchangeRate.currencies
      },
      ...mapGetters('settings', ['countries'])
    },
    watch: {
      navigareCompany() {
        this.navigareCompanyDirty = cloneDeep(this.navigareCompany)
      }
    },
    methods: {
      async submit() {
        let validated = await this.$validator.validate()

        if (!validated) return

        this.save()
      },
      async save() {
        this.submitting = true

        let formData = {
          country_id: this.navigareCompanyDirty.country_id,
          name: this.navigareCompanyDirty.name,
          tax_id: this.navigareCompanyDirty.tax_id,
          bank_accounts: this.navigareCompanyDirty.bank_accounts,
          contact_details: {
            email: this.navigareCompanyDirty.contact_details.email,
            telephone: this.navigareCompanyDirty.contact_details.telephone,
            address: this.navigareCompanyDirty.contact_details.address,
            delivery_address: this.navigareCompanyDirty.contact_details.delivery_address,
            city: this.navigareCompanyDirty.contact_details.city
          },
          representative_name: this.navigareCompanyDirty.representative_name,
          parent: this.navigareCompanyDirty.parent
        }

        try {
          let navigareCompany = await NavigareCompany.api.save(formData, this.navigareCompanyDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Company Saved',
            'color': 'success'
          })
          this.modalVisible = false
          this.$emit(this.navigareCompanyDirty.id ? 'navigareCompany:updated' : 'navigareCompany:created', navigareCompany)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.submitting = false
        }
      },
      async deleteNavigareCompany() {
        this.deleting = true

        try {
          await NavigareCompany.api.destroy(this.navigareCompanyDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Company deleted',
            'color': 'info'
          })
          this.modalVisible = false
          this.$emit('navigareCompany:deleted', this.navigareCompanyDirty.id)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.deleteConfirmationDialogVisible = false
          this.deleting = false
        }
      },
      addBankAccount() {
        this.navigareCompanyDirty.bank_accounts.push(cloneDeep(NavigareCompany.emptyBankAccount))
      },
      removeBankAccount(index) {
        if (index === 0 && this.navigareCompanyDirty.bank_accounts.length === 1) {
          this.navigareCompanyDirty.bank_accounts = [ cloneDeep(NavigareCompany.emptyBankAccount) ]
        } else {
          this.navigareCompanyDirty.bank_accounts.splice(index, 1)
        }
      }
    }
  }
</script>
